import { identity } from 'lodash';
import { handleAggregatorResponse } from '../../services/aggregator';
import createAction from '../../services/create-action';
export const fetchTagsRequest = createAction('tags/FETCH_REQUEST');
export const fetchTagsSuccess = createAction('tags/FETCH_SUCCESS', (payload, meta) => payload, (payload, meta) => meta);
export const fetchTagsFailure = createAction('tags/FETCH_FAILURE');
const fetchTagsAction = ({ onlyWithPublishedPosts = false, labelStarts, limit = 500, mostPopular = false, language, } = {}) => (dispatch, _getState, { request }) => {
    const multipleFilters = [onlyWithPublishedPosts, labelStarts, language].filter(identity).length >
        1;
    const filter = multipleFilters
        ? {
            $and: [
                onlyWithPublishedPosts && { publicationCount: { $gt: 0 } },
                labelStarts && { label: { $startsWith: labelStarts } },
                language && { language: { $eq: language } },
            ].filter(identity),
        }
        : {
            ...(onlyWithPublishedPosts && { publicationCount: { $gt: 0 } }),
            ...(labelStarts && { label: { $startsWith: labelStarts } }),
            ...(language && { language: { $eq: language } }),
        };
    return request.post('/v2/tags/query', {
        filter,
        paging: {
            offset: 0,
            limit,
        },
        ...(mostPopular && {
            sort: [{ fieldName: 'publicationCount', order: 'DESC' }],
        }),
    }, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
const createFetchTags = (action) => (args = {}) => (dispatch) => {
    dispatch(fetchTagsRequest());
    return dispatch(action(args))
        .then(({ tags }) => dispatch(fetchTagsSuccess(tags, Boolean(args.mostPopular))))
        .catch(() => dispatch(fetchTagsFailure()));
};
export const fetchTags = createFetchTags(fetchTagsAction);
export const handleTagsResponse = createFetchTags(handleAggregatorResponse);
export default fetchTags;
//# sourceMappingURL=fetch-tags.js.map